import Vue from 'vue';
import { getModuleNamespace } from '../../../../utils';

export default {
    clearMMYData: (state) => state.mmyData = [],
    addMMYRow: function(state) {
        let activeCableSelection = getModuleNamespace(this, state)[0];
        if (activeCableSelection.includes("AG26") || activeCableSelection.includes("AG-CBL")) {
            state.mmyData.push({'productId': 68, 'assetType': '', 'trailerType':'', 'diagnosticsCoverage': '', 'make': '', 'model':'', 'year': '', 'diagnosticsPortType': '', 'quantity': 0})
        } else {
            state.mmyData.push({'productId': 24, 'make': '', 'model':'', 'year': '', 'quantity': 0})
        }
    },
    addEmeaMMYRow: (state) => state.mmyData.push({'make': '', 'vehicleType':'', 'year': '', 'quantity': 0, 'remoteTacho': 'Not applicable', 'FMSGateway': 'Not applicable'}),
    removeRow: (state, index) => state.mmyData.splice(index, 1),
    clearAttribute: (state, payload) => state.mmyData[payload.index][payload.attribute] = '',
    setMMYData: (state, payload) => state.mmyData = payload,
    setSubmittedMMYData: (state, payload) => state.submittedMMYData = payload,
    clearSubmittedMMYData: (state) => state.submittedMMYData = [],
    setRowAttribute: (state, payload) => {
        Vue.set(state.mmyData[payload.index], [payload.attribute], payload.value)
    }
}
